export default "__VITE_ASSET__CXEjW_hQ__"